import Pagination from './pagination'

export { pageType, IPaginationProps } from './pagination'
export default Pagination
